module.exports = __webpack_public_path__ + "static/media/Grand-Hyatt.35fd657c.png";